import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { addFavouriteList, changeFavouritesList } from "../../../stateManagement/reducers/FavouritesSlice";
import { store } from "../../../stateManagement/store";
import { AddFavouriteListItem } from "../addFavouriteListItem";
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver/webStorageSaver";

// Компонент - модальное окно добавления в закладки
export function AddFavouriteModal({ objectInfo }: any) {
    // получаем флаг для отображения модального окна добавления в закладки
    const addFavouriteModalIsShown = useAppSelector(state => state.favourites.addToFavouriteModalIsShown)
    // получаем список текущих закладок
    let favouriteLists = useAppSelector(state => state.favourites.lists)

    const [showValueWarning, setShowValueWarning] = useState<boolean>(false)
    const [noValueWarning, setNoValueWarning] = useState<boolean>(false)
    function changeInput(text: any) {
        setValue(text)
        setShowValueWarning(false)
        setNoValueWarning(false)
    }
    const [value, setValue] = useState('');
    const dispatch = useDispatch()

    // функция создания нового списка закладок
    function addNewList() {
        if (value) {
            let lists: any
            lists = getItemWebStorage("favourites") ? getItemWebStorage("favourites") : store.getState().favourites.lists
            if (!lists.find((list: any) => list.name === value)) {
                if (getItemWebStorage("favourites")) {
                    dispatch(changeFavouritesList(lists))
                }
                dispatch(addFavouriteList(value))
                const favourites = store.getState().favourites.lists
                setItemWebStorage('favourites', favourites)
            } else setShowValueWarning(true)
        } else setNoValueWarning(true)
    }

    return (
        <div className="position-relative">
            {addFavouriteModalIsShown &&
                <div className="add-favourite-div">
                    {/* списки закладок */}
                    {favouriteLists.length > 0 &&
                        <p>Списки закладок</p>
                    }
                    {favouriteLists.map((item: any) => {
                        return (<AddFavouriteListItem name={item.name} objectInfo={objectInfo}/>)
                    })}
                    {showValueWarning && <small className="warning">Список с таким названием уже существует</small>}
                    {noValueWarning && <small className="warning">Введите название списка</small>}
                    {/* форма создания нового списка */}
                    <div className="d-flex add-favourite-form">
                        <Button icon="pi pi-plus" severity="success" onClick={addNewList} />
                        <InputText value={value} onChange={(e) => changeInput(e.target.value)} placeholder="Новый список" />
                    </div>
                </div>
            }
        </div>

    );
}

